var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';
import defaultAvatar from '../images/default_avatar_1.png';
import icon_search from "../images/icon_search.png";
import { getAvatarGradient } from "./gradient_generator";
import './index.less';
import IconFont from '../IconFontV2';
var nameType;
(function (nameType) {
    nameType[nameType["others"] = 0] = "others";
    nameType[nameType["enOneWord"] = 1] = "enOneWord";
    nameType[nameType["enTwoWords"] = 2] = "enTwoWords";
    nameType[nameType["zh"] = 3] = "zh";
})(nameType || (nameType = {}));
var zhPattern = /[\u4E00-\u9FA5]+/;
var enOneWordPattern = /[A-Za-z0-9]+/;
var enTwoWordsPattern = /[A-Za-z0-9]+[$][A-Za-z0-9]+/;
var defaultSize = 36;
var applyRule = function (name, type) {
    if (type === "team") {
        return teamRule(name);
    }
    return defaultRule(name);
};
export default function Avatar(props) {
    var styleObj = props.styleObj, src = props.src, tag = props.tag, name = props.name, defaultImg = props.defaultImg, className = props.className, onClick = props.onClick, onLoadError = props.onLoadError, size = props.size, fullName = props.fullName, searchIcon = props.searchIcon, customNameRule = props.customNameRule, _a = props.avatarMask, avatarMask = _a === void 0 ? true : _a, _b = props.type, type = _b === void 0 ? "user" : _b, _c = props.userBgColors, userBgColors = _c === void 0 ? ["#0073FF,#0073FF"] : _c, _d = props.groupBgColors, groupBgColors = _d === void 0 ? ["#0049F6,#0049F6"] : _d;
    // const applyRule = (name: string) => {
    //     if (customNameRule) {
    //         return customNameRule(name);
    //     }
    //     return defaultRule(name);
    // }
    var tagZoom = useMemo(function () {
        try {
            var avatarWidth = Number(String((styleObj === null || styleObj === void 0 ? void 0 : styleObj.width) || size || defaultSize).replace("px", "")) || 50;
            if (isNaN(avatarWidth)) {
                avatarWidth = 50;
            }
            return avatarWidth / 80;
        }
        catch (error) {
            return 0.5;
        }
    }, [size, styleObj]);
    var divAvatarNode = useMemo(function () {
        if (name) {
            var displayName = fullName ? name : applyRule(name, type);
            var gradientConfigs = type === 'group' ? groupBgColors : userBgColors;
            return (React.createElement("div", { className: "me-avatar " + (avatarMask ? "avatar-mask" : "") + " " + (className || ''), style: __assign({ width: size || defaultSize, height: size || defaultSize, borderRadius: 6, fontSize: 13, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', outline: 0, 
                    // fontWeight: "bold",  // 与服务端同步，不加粗
                    background: getAvatarGradient(displayName, gradientConfigs) }, styleObj), onClick: onClick },
                type === 'group' ? React.createElement(IconFont, { color: "#fff", style: { fontSize: '18px' }, type: "iconFrame12" }) : displayName,
                tag && (React.createElement("div", { className: avatarMask ? "avatar-tag-mask" : "", style: {
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        textAlign: "center",
                        lineHeight: "24px",
                        right: 0,
                        zoom: tagZoom,
                        whiteSpace: "nowrap",
                        fontSize: "16px",
                        backgroundColor: "#ED6A0C",
                        color: "#ffffff"
                    } }, tag))));
        }
        if (searchIcon) {
            return (React.createElement("div", { className: "me-avatar " + (className || ""), style: __assign({ width: size || defaultSize, height: size || defaultSize, borderRadius: 6, fontSize: 16, display: "flex", textAlign: "center", justifyContent: "center", alignItems: "center", overflow: "hidden", outline: 0 }, styleObj), onClick: onClick },
                React.createElement("img", { src: icon_search, alt: "", width: "15px" })));
        }
        return null;
    }, [name, searchIcon, fullName, className, size, styleObj, onClick, tag, customNameRule]);
    var imgAvatarNode = useMemo(function () {
        return (React.createElement("div", { draggable: "false", className: "me-avatar", style: {
                background: "none"
            } },
            React.createElement("img", { onDragStart: function (e) {
                    return false;
                }, className: className + " user-card-avatar-remote " + (avatarMask ? "avatar-mask" : "") + " avatar-img-no-drag", style: __assign({ width: size || defaultSize, height: size || defaultSize, borderRadius: 6, backgroundSize: 'cover', backgroundColor: 'transparent', overflow: 'hidden', outline: 0, display: "block", backgroundPositionY: "center" }, styleObj), onError: function (e) {
                    if (e.target) {
                        e.target.src = defaultImg || defaultAvatar;
                    }
                    if (onLoadError) {
                        onLoadError();
                    }
                }, onClick: onClick, src: src }),
            tag && (React.createElement("div", { className: avatarMask ? "avatar-tag-mask" : "", style: {
                    position: "absolute",
                    bottom: 0,
                    textAlign: "center",
                    borderRadius: "0 0 6px 6px",
                    left: 0,
                    lineHeight: "24px",
                    right: 0,
                    whiteSpace: "nowrap",
                    zoom: tagZoom,
                    fontSize: "16px",
                    backgroundColor: "#ED6A0C",
                    color: "#ffffff"
                } }, tag))));
    }, [className, size, styleObj, onClick, src, tag, onLoadError]);
    var filteredSrc = "";
    if (src) {
        filteredSrc = filterUselessImg(src);
    }
    if (!filteredSrc) {
        return divAvatarNode;
    }
    else {
        return imgAvatarNode;
    }
}
export function filterUselessImg(imgUrl) {
    if (imgUrl.includes("ebook.avatar.getDefaultAvatar")) {
        return "";
    }
    return imgUrl;
}
function teamRule(name) {
    // 1. 纯汉字 - 从头到尾都是汉字
    var pureChinesePattern = /^[\u4E00-\u9FA5]+$/;
    // 2. 纯英文 - 从头到尾都是英文字母
    var pureEnglishPattern = /^[A-Za-z]+$/;
    // 3. 纯数字 - 从头到尾都是数字
    var pureNumberPattern = /^[0-9]+$/;
    // 4. 中文开头 - 以汉字开头的任意文本
    var chineseFirstPattern = /^[\u4E00-\u9FA5]/;
    // 5. 英文开头 - 以英文字母开头的任意文本
    var englishFirstPattern = /^[A-Za-z]/;
    // 6. 纯符号 - 只包含符号，不包含中文、英文字母和数字
    var pureSymbolPattern = /^[^\u4E00-\u9FA5A-Za-z0-9\s]+$/;
    var filteredName = filterTeamName(name);
    var str;
    if (pureChinesePattern.test(filteredName) || chineseFirstPattern.test(filteredName) || pureNumberPattern.test(filteredName)) {
        str = filteredName.slice(0, 2);
    }
    else if (pureEnglishPattern.test(filteredName) || englishFirstPattern.test(filteredName)) {
        str = filteredName.slice(0, 1);
    }
    else if (pureSymbolPattern.test(filteredName)) {
        str = "租户";
    }
    return str || "租户";
}
function filterTeamName(name) {
    return name
        .trim()
        .split("")
        .filter(function (char) {
        return !/\s/.test(char); // 只过滤掉空格，保留所有其他字符
    })
        .join("");
}
function defaultRule(name) {
    // 1. 纯汉字 - 从头到尾都是汉字
    var pureChinesePattern = /^[\u4E00-\u9FA5]+$/;
    // 3. 数字开头 
    var numberFirstPattern = /^[0-9]/;
    // 4. 中文开头 - 以汉字开头的任意文本
    var chineseFirstPattern = /^[\u4E00-\u9FA5]/;
    // 5. 英文开头 - 以英文字母开头的任意文本
    var englishFirstPattern = /^[A-Za-z]/;
    // 6. 纯符号 - 只包含符号，不包含中文、英文字母和数字
    var pureSymbolPattern = /^[^\u4E00-\u9FA5A-Za-z0-9\s]+$/;
    var filteredName = filterName(name);
    var str;
    if (pureChinesePattern.test(filteredName) || chineseFirstPattern.test(filteredName)) {
        str = filteredName.slice(-2);
    }
    else if (englishFirstPattern.test(filteredName) || numberFirstPattern.test(filteredName)) {
        str = filteredName.slice(0, 1);
    }
    else if (pureSymbolPattern.test(filteredName)) {
        str = "用户";
    }
    return str || "用户";
}
function filterName(name) {
    return name
        .trim()
        .split('')
        .filter(function (char) {
        return zhPattern.test(char) || enOneWordPattern.test(char) || /\s/.test(char);
    })
        .join('');
}
//# sourceMappingURL=index.js.map